import { QueryClient } from "@tanstack/react-query";

/**
 * The application's query cache, created outside the React tree.
 *
 * Writes to customer and project data happen in sagas, and a saga has no way to reach the
 * QueryClientProvider. Without this module the only place to invalidate after a write was the
 * component that dispatched the action - which invalidates before the request has finished and
 * only knows about the caches that one screen uses.
 */
// A 401 or 403 is answered by the private Axios instance (refresh, device dialog, end of session). Trying the
// same query again would only repeat that, so it is not retried.
export const shouldRetryQuery = (failureCount, error) =>
    failureCount < 1 && ![401, 403].includes(error?.response?.status);

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 1000,
            retry: shouldRetryQuery,
        },
    },
});
